module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA9klEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4Ei/7EBqAagaqAKuAYgG6gHnwYg6+/fv0ASqAEuh08DUB0UycnB2UDpN++/fHhy4NndIy/efPrz9x9CA8TRCCetWNHbv/f/n88Hzt2aObUopbT55Knrr959RbJh+nS/wh1wDdVd+4H6fzyYemlzxpL+lAULM2fNmXX00nokDVjBzbTfZ8wOlec/a9A4fvGOW0UZIQ3nrX5fjLm8eunLBQFX33w0TE8noOH37bIdW3yf3D317eSqQ69edy1eTEDDiUMTt2/U39bvfHjVtId7Z+x/8xC7BgLxMCgBAFf6hMclZ214AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_british-antarctic-territory.png
// module id = 1310
// module chunks = 0